import LayerSectionBase from './LayerSectionBase.js';

export default class FrameSection extends LayerSectionBase {
  constructor(imageDataManager, selection, layerSection, requestDraw, doChange) {
    super(document.querySelector('#frameSection'), selection, requestDraw, {
      'New': {
        execute: () => this._do('add-frame', this.getDisplayIdxSelected(), 1), 
        check: () => this._getDisplaySzSelected() <= 1,
      },
      'Duplicate': {
        execute: () => this._do('duplicate-frame', ...this._getDisplayIdxSzSelected()),
        check: () => this._getDisplaySzSelected() >= 1,
      },
      'Delete': {
        execute: () => this._do('delete-frame', ...this._getDisplayIdxSzSelected()),
        check: () => this._getDisplaySzSelected() >= 1,
      },
    });
    this._imageDataManager = imageDataManager;
    this._layerSection = layerSection;
    this._do = doChange;
    this._setResizeObserverX(x => {
      const elOjectSection = document.querySelector('#objectSection');
      elOjectSection.style.right = `calc(${window.innerWidth - x}px + 1vh)`;
    });
  }
  _selectInnerData(idx) {
    this._imageDataManager.selectFrame(idx);
    const sz = this._imageDataManager.getLayerDataListSz(idx);
    this._layerSection.reset(sz);
  }
  _drawThumbnail(canvas, idx) {
    this._imageDataManager.drawFrameThumbnail(canvas, idx);
  }
  _doMove(srcIdx, srcSz, dstIdx) {
    this._do('move-frame', srcIdx, srcSz, dstIdx);
  }
  _onDisplayClick(e) {
    const layerIdx = this._layerSection.getDisplayIdxSelected();
    super._onDisplayClick(e);
    this._layerSection.select2(layerIdx);
  }
  add(idx, sz, show = true) {
    this._addDisplays(idx, sz, show);
    this._imageDataManager.addFrame(idx, sz);
  }
  insert(idx, ...targets) {
    this._addDisplays(idx, targets.length);
    this._imageDataManager.insertFrame(idx, ...targets)
  }
  duplicate(idx, sz) {
    this._addDisplays(idx, sz);
    this._imageDataManager.duplicateFrame(idx, sz);
    this._updateThumbnails(idx, sz);
  }
  delete(idx, sz) {
    this._deleteDisplays(idx, sz);
    return this._imageDataManager.deleteFrame(idx, sz);
  }
  move(srcIdx, srcSz, dstIdx) {
    this._imageDataManager.moveFrame(srcIdx, srcSz, dstIdx);
    this._moveDisplays(srcIdx, srcSz, dstIdx);
  }
}
